import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgArrowDoubleDown = (props) => {
    const { color } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: "M18.707 5.706a1 1 0 0 0-1.412-1.413L12 9.593l-5.295-5.3a.998.998 0 1 0-1.413 1.413l6.002 6.006a.998.998 0 0 0 1.412 0l6.002-6.006Z", fill: color }),
        React.createElement("path", { d: "M18.707 13.7a1 1 0 0 0-1.412-1.412L12 17.587l-5.295-5.3A.998.998 0 1 0 5.292 13.7l6.002 6.006a.998.998 0 0 0 1.412 0l6.002-6.006Z", fill: color })));
};
export default factorySvgIcon(SvgArrowDoubleDown);
//# sourceMappingURL=SvgArrowDoubleDown.js.map